"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TBTestimonials = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@storyblok/react");
var TopiaCaseStudyList_1 = require("../TopiaCaseStudyList");
function TBTestimonials(_a) {
    var blok = _a.blok;
    var testimonials = [];
    var numRows = 1;
    if (blok.testimonial_block.length > 3) {
        numRows = 2;
    }
    else if (blok.testimonial_block.length > 7) {
        numRows = 3;
    }
    var blocksPerRow = Math.ceil(blok.testimonial_block.length / numRows);
    for (var row = 0; row < numRows; row++) {
        var rowBlocks = [];
        for (var col = 0; col < blocksPerRow; col++) {
            var ix = row * blocksPerRow + col;
            if (ix < blok.testimonial_block.length) {
                rowBlocks.push(blok.testimonial_block[ix]);
            }
        }
        testimonials.push(rowBlocks);
    }
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, (0, react_1.storyblokEditable)(blok), { children: (0, jsx_runtime_1.jsxs)("div", { className: "bg-slate-950 flex flex-col items-center py-12", children: [(0, jsx_runtime_1.jsxs)("div", { className: "mb-8 px-4", children: [(0, jsx_runtime_1.jsx)("h3", { className: "text-center text-4xl font-semibold text-slate-500", children: blok.title }), (0, jsx_runtime_1.jsx)("p", { className: "mx-auto mt-2 max-w-lg text-center text-sm text-slate-300", children: blok.subtitle })] }), (0, jsx_runtime_1.jsxs)("div", { className: "relative max-w-7xl overflow-x-hidden p-4", children: [(0, jsx_runtime_1.jsx)("div", { className: "absolute top-0 bottom-0 left-0 z-10 w-24 bg-gradient-to-r from-slate-900 to-transparent" }), testimonials.map(function (row, ix) { return ((0, jsx_runtime_1.jsxs)("div", { className: "mb-4 flex items-center", children: [(0, jsx_runtime_1.jsx)(TopiaCaseStudyList_1.TopiaCaseStudyList, { blok: blok, duration: row.length > 2 ? 20 : 10, list: row, reverse: ix % 2 === 0 }), (0, jsx_runtime_1.jsx)(TopiaCaseStudyList_1.TopiaCaseStudyList, { blok: blok, duration: row.length > 2 ? 20 : 10, list: row, reverse: ix % 2 === 0 }), (0, jsx_runtime_1.jsx)(TopiaCaseStudyList_1.TopiaCaseStudyList, { blok: blok, duration: row.length > 2 ? 20 : 10, list: row, reverse: ix % 2 === 0 })] }, ix)); }), (0, jsx_runtime_1.jsx)("div", { className: "absolute top-0 bottom-0 right-0 z-10 w-24 bg-gradient-to-l from-slate-900 to-transparent" })] })] }) })));
}
exports.TBTestimonials = TBTestimonials;
